import { getUserServiceUrl } from '../config/config'
import type { AuthTokens } from './cookieUtils'

type ApiResponse<T> = {
  data: T
  message: string
  status: number
}

async function post<T>(
  path: string,
  body: Record<string, unknown>,
  accessToken?: string,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`
  }

  const response = await fetch(`${getUserServiceUrl()}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const errorData = await response
      .json()
      .catch(() => ({ message: response.statusText }))
    const message =
      (errorData as { message?: string }).message ?? response.statusText
    throw new ApiError(message, response.status)
  }

  const json = (await response.json()) as ApiResponse<T>
  return json.data
}

export class ApiError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

export async function initiateLogin(email: string): Promise<void> {
  await post('/api/v1/auth/passwordless/login', { email })
}

export async function verifyOtp(
  email: string,
  otp: string,
): Promise<AuthTokens> {
  return post<AuthTokens>('/api/v1/auth/passwordless/verify', { email, otp })
}

export async function refreshAccessToken(
  refreshToken: string,
): Promise<AuthTokens> {
  return post<AuthTokens>('/api/v1/auth/refresh', {
    refresh_token: refreshToken,
  })
}

export async function logoutUser(
  accessToken: string,
  refreshToken: string,
): Promise<void> {
  await post(
    '/api/v1/auth/passwordless/logout',
    { refresh_token: refreshToken },
    accessToken,
  )
}
